import { render, staticRenderFns } from "./yours.vue?vue&type=template&id=df83f9e0"
import script from "./yours.vue?vue&type=script&lang=js"
export * from "./yours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports